import {useState} from "react";
import {toast} from "react-hot-toast";
import {alterarSenha} from "../../services/usuarioService";
import {setToken, justLogout} from "../../services/authService";
import './ModalAlterarSenha.scss';

interface ModalAlterarSenhaProps {
    onSenhaAlterada: () => void;
    token: string;
}

export default function ModalAlterarSenha({onSenhaAlterada, token}: ModalAlterarSenhaProps) {
    const [novaSenha, setNovaSenha] = useState<string>("");
    const [confirmarSenha, setConfirmarSenha] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<{novaSenha?: string; confirmarSenha?: string}>({});

    function validate(): boolean {
        const newErrors: {novaSenha?: string; confirmarSenha?: string} = {};

        if (!novaSenha) {
            newErrors.novaSenha = "Nova senha é obrigatória";
        } else if (novaSenha.length < 6) {
            newErrors.novaSenha = "Mínimo de 6 caracteres";
        }

        if (!confirmarSenha) {
            newErrors.confirmarSenha = "Confirmação é obrigatória";
        } else if (novaSenha !== confirmarSenha) {
            newErrors.confirmarSenha = "Senhas não coincidem";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    async function handleSubmit(e: any) {
        e.preventDefault();

        if (!validate()) {
            return;
        }

        setLoading(true);
        try {
            setToken(token);
            await alterarSenha(novaSenha, confirmarSenha);
            toast.success("Senha alterada com sucesso");
            onSenhaAlterada();
        } catch (error: any) {
            justLogout();
            toast.error(error.message || "Erro ao alterar senha");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <div className="modal-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ff6a39" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                </div>
                <h2 className="modal-title">Alterar Senha</h2>
                <p className="modal-subtitle">
                    Você está logando com a senha padrão. Por favor, crie uma nova senha para continuar.
                </p>
                <form onSubmit={handleSubmit}>
                    <div className="field">
                        <label htmlFor="novaSenha">Nova Senha</label>
                        <input
                            type="password"
                            id="novaSenha"
                            placeholder="Digite sua nova senha"
                            value={novaSenha}
                            onChange={(e) => setNovaSenha(e.target.value)}
                            className={errors.novaSenha ? 'input-error' : ''}
                        />
                        {errors.novaSenha && <span className="error-text">{errors.novaSenha}</span>}
                    </div>
                    <div className="field">
                        <label htmlFor="confirmarSenha">Confirmar Senha</label>
                        <input
                            type="password"
                            id="confirmarSenha"
                            placeholder="Confirme sua nova senha"
                            value={confirmarSenha}
                            onChange={(e) => setConfirmarSenha(e.target.value)}
                            className={errors.confirmarSenha ? 'input-error' : ''}
                        />
                        {errors.confirmarSenha && <span className="error-text">{errors.confirmarSenha}</span>}
                    </div>
                    <button type="submit" disabled={loading} className="btn-submit">
                        {loading ? (
                            <span className="spinner"></span>
                        ) : (
                            'Salvar Nova Senha'
                        )}
                    </button>
                </form>
            </div>
        </div>
    )
}
